module.exports = __webpack_public_path__ + "img/money_mountain_01.f21844b9.png";